import { type ReactNode } from 'react';
import classNames from 'classnames';
import { GRADIENT_ICON_VARIANT } from '@/types';
import styles from './GradientIcon.module.sass';

type GradientIconProps = {
  icon: ReactNode;
  variant?: GRADIENT_ICON_VARIANT;
};

export const GradientIcon = ({ icon, variant = GRADIENT_ICON_VARIANT.GRAY }: GradientIconProps) => {
  return <div className={classNames(styles.iconWrapper, styles[variant])}>{icon}</div>;
};
